import { styled } from 'styled-components'

export const MainWrapper = styled.div`
    width: 100%;
    padding: ${props => `${props.theme.marginXS}px 0`};
    display: flex;
    justify-content: center;
    border-bottom: solid 1px ${props => props.theme.colorBorderSecondary};
`
